/* global google */
import React, { Component } from "react";
import { Row, Col } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { Map, Marker, GoogleApiWrapper, InfoWindow } from "google-maps-react";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import '../css/GoogleMap.css'
import Swal from 'sweetalert2/dist/sweetalert2.js';

// const directionsService = new window.google.maps.DirectionsService();
// const directionsDisplay = new window.google.maps.DirectionsRenderer();

// var iconurl ='https://mapicons.mapsmarker.com/wp-content/uploads/mapicons/shape-default/color-ff0000/shapecolor-white/shadow-1/border-color/symbolstyle-color/symbolshadowstyle-no/gradient-no/fillingstation.png';
// var dataBytes;
// var request = http.get(iconurl);
// var bytes = request.bodyBytes;


const places = [
    {
        name: 'Hyderabad',
        title: 'Hyderabad',
        lat: 25.3835549,
        lng: 68.2968657,
        id: 1
    },
    {
        name: 'Sukkur',
        title: 'Sukkur',
        lat: 27.717606,
        lng: 68.7986344,
        id: 2
    },
    {
        name: 'Lahore',
        title: 'Lahore',
        lat: 31.4826352,
        lng: 74.0541981,
        id: 3
    }
];

class LocationSearchInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            address: "",
            latlng: {}
        };
        this.placesService = new window.google.maps.places.PlacesService(
            document.createElement("div")
        );
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }

    handleChange = address => {
        this.setState({ address });
    };

    handleSelect = (address, placeId) => {
        this.setState({ address });



        const request = {
            placeId: placeId,
            fields: ["name", "geometry"]
        };
        this.placesService.getDetails(request, (place, status) => {
            if (status == google.maps.places.PlacesServiceStatus.OK) {

                geocodeByAddress(address)
                    .then(results => getLatLng(results[0]))
                    .then(latLng => {
                        console.log('Success', latLng)
                        this.setState({ latlng: latLng })
                    })
                    .catch(error => console.error('Error', error));

                place.latlng = this.state.latlng
                console.log('component place', place)
                if (this.props.type === 'source')
                    this.props.onSourceChanged(place);
                else if (this.props.type === 'destination')
                    this.props.onDestinationChanged(place);

                //console.log('lat long are', this.state.latlng)
                //this.props.onLocationChanged(this.state.latlng);
            }
        });
    };

    render() {
        return (
            <PlacesAutocomplete
                value={this.state.address}
                onChange={this.handleChange}
                onSelect={this.handleSelect}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                    <div className="autocomplete-container">
                        <input
                            {...getInputProps({
                                placeholder: "Search Places ...",
                                className: "form-control"
                            })}
                        />

                        <div className="autocomplete-dropdown-container">
                            {loading && <div>Loading...</div>}
                            {suggestions.map(suggestion => {
                                const className = suggestion.active
                                    ? "suggestion-item--active"
                                    : "suggestion-item";
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                    ? { backgroundColor: "#fafafa", cursor: "pointer" }
                                    : { backgroundColor: "#ffffff", cursor: "pointer" };
                                return (
                                    <div
                                        {...getSuggestionItemProps(suggestion, {
                                            className,
                                            style
                                        })}
                                    >
                                        <span>{suggestion.description}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
        );
    }
}

class MapContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            places: [],
            source: [],
            destination: [],
            // dataBytes: bytes,
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            triangleCoords: [
                { lat: 24.854212, lng: 67.026306 },
                { lat: 24.8586755, lng: 67.0224131 },
                { lat: 24.852905, lng: 67.032330 }
            ],
            pumps: this.props.outlets,
            // allSelectedPlaces: []
            allSelectedPlaces: this.props.allSelectedOutlet
        };
        this.showPlace = this.showPlace.bind(this);
        this.createRoute = this.createRoute.bind(this)
        this.setDestination = this.setDestination.bind(this)
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.removePointer = this.removePointer.bind(this);
        this.sendSelectedPointerData = this.sendSelectedPointerData.bind(this);
        this.mapRef = React.createRef();



        console.log(this.props.allSelectedOutlet, "selected outlets");
    }

    componentDidUpdate(prevProps, prevState) {
        debugger
        if (prevState.allSelectedPlaces !== this.state.allSelectedPlaces) {
          console.log('Updated state:', this.state.allSelectedPlaces);
          this.sendSelectedPointerData();
        }
      }
      
      
      
      
      
      
      
    sendSelectedPointerData = () => {
        this.props.parentOutletNameCallback(this.state.allSelectedPlaces)
    }
  


    createRoute() {

        const directionsService = new window.google.maps.DirectionsService();
        const directionsDisplay = new window.google.maps.DirectionsRenderer();

        directionsDisplay.setMap(this.mapRef.current.map);

        let request = {
            origin: this.state.source[0].geometry.location,
            //waypoints: waypoints,
            destination: this.state.destination[0].geometry.location,
            travelMode: "DRIVING",
        };
        //show results in the directionsrenderer
        directionsService.route(request, function (result, status) {
            if (status == "OK") {
                directionsDisplay.setDirections(result);
            }
        });


    }

    showPlace(place) {
        this.setState(prevState => ({
            source: [place]
        }));
    }

    setDestination(place) {
        this.setState(prevState => ({
            destination: [place]
        }));
    }

    setLocation(place) {
    }

    displayMarkers = () => {
        console.log('setting pointers')
        return this.state.pumps.map((store, index) => {
            return <Marker
                key={index}
                id={store.outletID}
                name={store.outletName}
                title={store.outletName} position={{
                    lat: store.latitude,
                    lng: store.longitude
                }}
                icon='imageassets/fillingstation.png'
                onClick={this.onMarkerClick}
            />
        })
    }

    async onMarkerClick(props, marker, e) {
        debugger
        console.log('on marker clicked')

        console.log('e: ' +  e);

        if (this.state.allSelectedPlaces.some(e => e.outletID === props.id)) {
            Swal.fire({
                text: 'Selected site already exists',
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else {
            await this.setState((prevState) => ({
                allSelectedPlaces: [...prevState.allSelectedPlaces, { outletID: props.id, outletName: props.name }]
            }));

            await this.setState({
                selectedPlace: props,
                activeMarker: marker,
                showingInfoWindow: true
            });
            this.sendSelectedPointerData();

        }




    }

    removePointer(pointerID) {
        //alert(pointerID)
        debugger
        var array = [...this.state.allSelectedPlaces];
        var index = pointerID//array.indexOf(pointerID)
        //console.log('index is now',index)
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ allSelectedPlaces: array });
        }
        debugger
        console.log(this.state.allSelectedPlaces)
        
        this.sendSelectedPointerData();
    }

    onMapReady = (mapProps, map) => {
        let coords = [];
        let waypoints = [];
        //put data from config file in an array
        {
            places.map((place) => coords.push({ lat: place.lat, lng: place.lng }));
        }
        console.log('map props', map)

        //instantiate directions service and directions renderer
        const directionsService = new window.google.maps.DirectionsService();
        const directionsDisplay = new window.google.maps.DirectionsRenderer();
        //put directions renderer to render in the map
        directionsDisplay.setMap(map);
        //Getting the first coordinate in the array as the start/origin
        let start = { lat: coords[0].lat, lng: coords[0].lng };
        //Getting the last coordinate in the array as the end/destination
        let end = {
            lat: coords[coords.length - 1].lat,
            lng: coords[coords.length - 1].lng,
        };

        //putting all the coordinates between the first and last coordinate from the array as the waypoints
        for (let i = 1; i < coords.length - 1; i++) {
            waypoints.push({
                location: { lat: coords[i].lat, lng: coords[i].lng },
                stopover: true,
            });
        }

        // directions requests

        let request = {
            origin: start,
            //waypoints: waypoints,
            destination: end,
            travelMode: "DRIVING",
        };
        //show results in the directionsrenderer
        directionsService.route(request, function (result, status) {
            if (status == "OK") {
                directionsDisplay.setDirections(result);
            }
        });

        //setting the autocomplete input
        let card = document.getElementById("pac-card");
        let input = document.getElementById("pac-input");
        map.controls[window.google.maps.ControlPosition.TOP_CENTER].push(card);
        let autocomplete = new window.google.maps.places.Autocomplete(document.getElementById('pac-input'));

        // Bind the map's bounds (viewport) property to the autocomplete object,
        // so that the autocomplete requests use the current map bounds for the
        // bounds option in the request.
        autocomplete.bindTo("bounds", map);

        // Set the data fields to return when the user selects a place.
        autocomplete.setFields(["address_components", "geometry", "icon", "name"]);

        //listener for the places input
        autocomplete.addListener("place_changed", function () {
            console.log(waypoints);
            let place = autocomplete.getPlace();
            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                window.alert("No details available for input: '" + place.name + "'");
                return;
            }

            //Putting the previous last coordinate in the array to be part of the waypoint
            waypoints.push({
                location: {
                    lat: coords[coords.length - 1].lat,
                    lng: coords[coords.length - 1].lng,
                },
                stopover: true,
            });

            //putting the Place Autocomplete coordinate result in the coords array
            coords.push({
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            });
            //putting the Place Autocomplete coordinate result the value of the end/destination
            end = place.geometry.location;

            //changing  request
            request = {
                origin: start,
                waypoints: waypoints,
                destination: end,
                travelMode: "DRIVING",
            };
            //creating new directions request

            directionsService.route(request, function (result, status) {
                if (status == "OK") {
                    directionsDisplay.setDirections(result);
                }
                else
                    console.log('direction request is : ', request)
            });
        });
    };

    render() {
        console.log("Pumps are : ", this.state.pumps)
        return (
            <>
                <Row>
                    <Col>&nbsp;</Col>
                    <Col>



                        Starting Point <LocationSearchInput onSourceChanged={this.showPlace} type={'source'} />
                    </Col>
                    <Col>
                        Destination <LocationSearchInput onDestinationChanged={this.setDestination} type={'destination'} />
                    </Col>
                    <Col>
                        <br />
                        <input className="btn btn-shell mr-1 mb-1" type='button' value='Create Route' onClick={this.createRoute}></input>
                    </Col>
                </Row>
                <Row>
                    <Col xs={2} className="p-0">
                        <h5>On-Route Sites</h5>
                        <ul class="list-group">
                            {
                                this.state.allSelectedPlaces.map((el, index) => {
                                    return (
                                        <li class="list-group-item small-font"><FeatherIcon className="iconspacing-Nav" icon="map-pin" size="10" />{el.outletName} &nbsp;<a href="#" onClick={() => this.removePointer(index)}>X</a></li>
                                    )
                                })
                            }
                        </ul>
                    </Col>
                    <Col style={{ position: "relative", height: "calc(100vh - 20px)" }}>
                        <Map
                            ref={this.mapRef}
                            google={this.props.google}
                            className={"map"}
                            zoom={6}
                            initialCenter={{ lat: 24.855869592298674 , lng: 67.0263810423295 }}
                        // onReady={this.onMapReady}
                        //onClick={this.onMapClicked}
                        >
                            {/* {this.state.places.map((place, i) => {
                                return <Marker key={i} position={place.geometry.location} />;
                            })} */}
                            {this.displayMarkers()}
                            <InfoWindow
                                marker={this.state.activeMarker}
                                visible={this.state.showingInfoWindow}
                            >
                                <div>
                                    <h6>{this.state.selectedPlace.name}</h6>
                                </div>
                            </InfoWindow>
                        </Map>

                    </Col>
                </Row>
            </>

        );
    }
}

export default GoogleApiWrapper({
    //apiKey: "AIzaSyCWMdwSY8Z1ifJTC2cDlAaB2-us_qYsn1c",
    apiKey: "AIzaSyAu3EBulpnOvJpzfYNyrj6JeSquSKjtdyY",
    libraries: ["places"]
})(MapContainer);
